// src/components/inbox/InboxRow.jsx
import React from "react";
import { Badge } from "../ui";
import StarsIcon from "../../styles/StarsIcon";
import { cn } from "../ui/cn";
import {
  factLine,
  paidLine,
  PILL_OVERDUE,
  rowPills,
  shortName,
} from "./inboxFormat";

// One conversation in the list. A row in the "No messages yet" group shows
// the paid line where other rows show the last message's preview.
export default function InboxRow({
  row,
  selected = false,
  noMessages = false,
  busy = false,
  onOpen,
}) {
  const fact = noMessages ? null : factLine(row);
  const pills = rowPills(row);
  return (
    <button
      type="button"
      data-slot="inbox-row"
      className={cn(
        "tw-relative tw-flex tw-w-full tw-cursor-pointer tw-flex-col tw-gap-1 tw-border-0 tw-border-l-2 tw-border-solid tw-px-4 tw-py-3 max-rail:tw-pr-8 tw-text-left tw-text-text hover:tw-bg-surface-sunken disabled:tw-cursor-not-allowed disabled:tw-opacity-45",
        "focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:-tw-outline-offset-2 focus-visible:tw-outline-focus-ring",
        selected
          ? "tw-border-text tw-bg-surface-sunken"
          : "tw-border-transparent tw-bg-transparent",
      )}
      aria-current={selected ? "true" : undefined}
      disabled={busy}
      onClick={() => onOpen(row)}
    >
      <span className="tw-flex tw-items-center tw-justify-between tw-gap-2">
        <span className="tw-inline-flex tw-items-center tw-gap-2 tw-text-sm tw-font-bold">
          {row.unread && (
            <span
              data-slot="inbox-dot"
              className="tw-h-2 tw-w-2 tw-flex-none tw-rounded-pill tw-bg-text-accent"
              aria-hidden="true"
            />
          )}
          {shortName(row.client)}
        </span>
        {fact && (
          <span
            data-waiting={row.waitingOnUs ? "true" : undefined}
            className={cn(
              "tw-whitespace-nowrap tw-text-xs tw-font-semibold",
              row.waitingOnUs ? "tw-text-warning" : "tw-text-text-muted",
            )}
          >
            {fact}
          </span>
        )}
      </span>
      <span className="tw-truncate tw-text-xs tw-text-text-muted">
        {noMessages ? paidLine(row) : row.preview?.text}
      </span>
      {pills.length > 0 && (
        <span className="tw-flex tw-flex-wrap tw-gap-1">
          {pills.map((p) => (
            <Badge key={p} tone={p === PILL_OVERDUE ? "warning" : "neutral"}>
              {p}
            </Badge>
          ))}
        </span>
      )}
      <StarsIcon
        name="chevron"
        className="tw-absolute tw-inset-y-0 tw-right-3 tw-my-auto tw-hidden tw-h-4 tw-w-4 tw-shrink-0 tw-text-text-muted max-rail:tw-block"
      />
    </button>
  );
}
